import React from 'react';
import PropTypes from 'prop-types';
import { parse } from 'date-fns';
import { useIntl } from 'react-intl';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { servicesPropTypes } from 'constants/propTypes';
import { updateIncrementsConfirmationModalMessages as messages } from './ScheduleIncrements.messages';

const UpdateIncrementsConfirmationModal = ({ serviceIds, increments, services }) => {
  const intl = useIntl();

  return (
    <Confirm
      title={<Message message={messages.title} />}
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.confirm} />}
      isOpen>
      <Message className="text--light text--sm" as="p" message={messages.services} />
      <p className="text--sm">
        {serviceIds.map(serviceId => services.find(({ id }) => id === serviceId)?.name).join(', ')}
      </p>
      <Message className="text--light text--sm" as="p" message={messages.increments} />
      <p className="text--sm">{increments.map(time => intl.formatTime(parse(time, 'HH:mm', new Date()))).join(', ')}</p>
    </Confirm>
  );
};

UpdateIncrementsConfirmationModal.propTypes = {
  serviceIds: PropTypes.arrayOf(PropTypes.number),
  increments: PropTypes.arrayOf(PropTypes.string),
  services: servicesPropTypes,
};

export default UpdateIncrementsConfirmationModal;
